import { useQuery } from "@tanstack/react-query";
import { useAPIs, useAuthenticatedAPI } from "@/api";

export function useSelf() {
  const api = useAuthenticatedAPI();

  return useQuery({
    queryKey: ["self"],
    queryFn: async () => {
      return api.getSelf();
    },
  });
}

export function useTrySelf() {
  const { authenticatedAPI } = useAPIs();

  return useQuery({
    queryKey: ["self"],
    queryFn: async () => {
      return authenticatedAPI!.getSelf();
    },
    enabled: Boolean(authenticatedAPI),
  });
}
